import { render, staticRenderFns } from "./studentAttendance.vue?vue&type=template&id=f1a870de&scoped=true&"
import script from "./studentAttendance.vue?vue&type=script&lang=js&"
export * from "./studentAttendance.vue?vue&type=script&lang=js&"
import style0 from "./studentAttendance.vue?vue&type=style&index=0&id=f1a870de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a870de",
  null
  
)

export default component.exports